module.exports = __webpack_public_path__ + "static/media/print-sgombero-detail2.cd890364.jpg";